
import moment from 'moment'
import {
  BusinessTripRate,
} from 'app/models/configuration/businessTripRatesConfigurationModel'

// @TODO: Unused
export function isRightDates(index: number, rates: BusinessTripRate[]): boolean {
  const currentRate = rates[index]
  for (let i = 0; i < rates.length; i++) {
    const current = rates[i]

    if (
      i != index &&
      current.country.name == currentRate.country.name &&
      ((current.dateTo == null &&
        (currentRate.dateTo == null ||
          moment(currentRate.dateTo) >= moment(current.dateFrom))) ||
        (current.dateTo != null &&
          ((moment(currentRate.dateFrom) >= moment(current.dateFrom) &&
            moment(currentRate.dateFrom) <= moment(current.dateTo)) ||
            (moment(currentRate.dateFrom) <= moment(current.dateFrom) &&
              (currentRate.dateTo == null ||
                moment(currentRate.dateTo) >= moment(current.dateFrom))))))
    ) {
      return false
    }
  }
  return true
}

export function runValidation(
  rates: BusinessTripRate[],
  translateFn: (text: string) => string,
) {
  const validation: any = {
    isValid: true,
    rates: { isInvalid: false, message: '' },
  }

  for (let index = 0; index < rates.length; index++) {
    if (validation.rates[index] == null) {
      validation.rates[index] = {}
    }

    const valid = isRightDates(index, rates)

    validation.rates[index].dateFrom = {
      isInvalid: !valid,
      message: !valid ? translateFn('configuration.businessTrips') : '',
    }
    validation.rates[index].dateTo = {
      isInvalid: !valid,
      message: !valid ? translateFn('configuration.businessTrips') : '',
    }
    validation.rates[index].country = {
      isInvalid: !valid,
      message: !valid ? translateFn('configuration.businessTrips') : '',
    }

    if (!valid) {
      validation.isValid = false
    }
  }

  return validation
}

export function emptyValidation() {
  return { isValid: true, rates: { isInvalid: false, message: '' } }
}
